import { IFormErrors } from '@interfaces/IFormsErrors';
import { ICompany, IGraduates, IVacancies } from '@interfaces/ICompany';

export interface ICompaniesViewState {
  isLoading: boolean;
  errors: IFormErrors | null;
  companies: {
    data: ICompany | null;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  graduates: {
    data: IGraduates | null;
    count: number;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
  vacancies: {
    data: IVacancies | null;
    count: number;
    isLoading: boolean;
    errors: IFormErrors | null;
  };
}

export const initialCompaniesViewState: ICompaniesViewState = {
  isLoading: false,
  errors: null,
  companies: {
    data: null,
    isLoading: false,
    errors: null,
  },
  graduates: {
    data: null,
    count: 0,
    isLoading: false,
    errors: null,
  },
  vacancies: {
    data: null,
    count: 0,
    isLoading: false,
    errors: null,
  },
};
